import type { ApiResponse } from '@dola/contracts';

export class ApiException extends Error {
  constructor(readonly status: number, readonly code: string, message: string, readonly details?: Record<string, unknown>) {
    super(message);
  }
}

export async function api<T>(path: string, options: RequestInit = {}): Promise<T> {
  const response = await fetch(`/api/admin${path}`, {
    credentials: 'same-origin',
    ...options,
    headers: {
      ...(options.body ? { 'content-type': 'application/json' } : {}),
      ...(options.headers || {})
    }
  });
  const contentType = response.headers.get('content-type') || '';
  if (!contentType.includes('application/json')) {
    if (!response.ok) throw new ApiException(response.status, 'HTTP_ERROR', `请求失败：HTTP ${response.status}`);
    return response as unknown as T;
  }
  const payload = await response.json() as ApiResponse<T>;
  if (!response.ok || !payload.ok) {
    const error = payload.ok ? null : payload.error;
    throw new ApiException(response.status, error?.code || 'API_ERROR', error?.message || '请求失败', error?.details);
  }
  return payload.data;
}

export async function mutate<T>(path: string, method: 'POST' | 'PUT' | 'PATCH' | 'DELETE', body: unknown, idempotencyKey?: string): Promise<T> {
  return api<T>(path, {
    method,
    body: JSON.stringify(body),
    headers: idempotencyKey ? { 'idempotency-key': idempotencyKey } : undefined
  });
}

export function formatTime(value: unknown): string {
  const number = Number(value || 0);
  if (!number) return '-';
  return new Intl.DateTimeFormat('zh-CN', { dateStyle: 'medium', timeStyle: 'short', hour12: false }).format(new Date(number * 1000));
}

export function formatDay(value: unknown): string {
  return String(value || '-');
}

export function formatCount(value: unknown): string {
  return new Intl.NumberFormat('zh-CN').format(Number(value || 0));
}
